import React, { useContext, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { SButton, SContainer, SError, SFormControl, SParagraph, STitle } from "../../components/BasicComponents";
import AppNavbar from "../../components/Navbars/AppNavbar";
import { AuthContext } from "../../context/AuthContext";
import { toastSuccess } from "../../utils/Toast";
import Loading from "../../components/Loading/Loading";
import { te } from "../../utils/errorsTranslation";
import { useEffect } from "react";

const ForgotPasswordPage = () => {
  const { t } = useTranslation("", { keyPrefix: "auth.forgot_password" });

  const [email, setEmail] = useState("");
  const { forgotPassword, loading, error, resetError } = useContext(AuthContext);
  const history = useHistory();

  useEffect(() => {
    return () => resetError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const onSubmit = (e) => {
    e.preventDefault();

    forgotPassword(email).then(() => {
      history.push("/login");
      toastSuccess("Email sent correctly");
    });
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <SContainer dark="true" fluid fill="true" className="d-flex flex-column">
          <Row>
            <AppNavbar dark="true" />
          </Row>
          <Container className="m-auto">
            <Col xl={4} lg={5} md={8} sm={10} className="d-flex flex-column flex-grow-1 justify-content-center">
              <STitle className="fs-1 fw-bolder mb-4 p-2 text-uppercase">{t("title")}</STitle>
              <SParagraph className="w-100 text-center mt-1 mb-0">{t("subtitle")}</SParagraph>
              <Form className="p-2" onSubmit={onSubmit}>
                <Form.Group className="p-2">
                  <SFormControl
                    type="email"
                    placeholder={t("email")}
                    className="my-3 fs-5"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <SButton type="submit" dark="true" className="mt-4 w-100 fs-5">
                    {t("send")}
                  </SButton>
                  {error && <SError>{te(error.message)}</SError>}
                  <SParagraph className="w-100 text-center mt-1 mb-0">
                    {t("no_account")} <Link to="/register">{t("sign_up")}</Link>
                  </SParagraph>
                </Form.Group>
              </Form>
            </Col>
          </Container>
        </SContainer>
      )}
    </>
  );
};

export default ForgotPasswordPage;
